import { render, staticRenderFns } from "./TripDates.vue?vue&type=template&id=1960b803&scoped=true&"
import script from "./TripDates.vue?vue&type=script&lang=js&"
export * from "./TripDates.vue?vue&type=script&lang=js&"
import style0 from "./TripDates.vue?vue&type=style&index=0&id=1960b803&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960b803",
  null
  
)

export default component.exports